import React from 'react'

export const homeScreenLinkHeader = props => (
  <h3>Add {props.appName} to Your Home Screen</h3>
)

export const homeScreenLinkBody = (
  <>
    <p>On iOS devices, load the application in Safari (homescreen link is not available on iOS Chrome). Then, tap the share icon followed by tapping "Add to Home Screen." Enter the desired name for the shortcut using the on-screen keyboard and tap "Add".</p>

    <p>On Android devices, tap the menu icon followed by tapping "Add to Home Screen." Enter the desired name for the shortcut using the on-screen keyboard and tap "Add".</p>
  </>
)